import { type ServiceMethod } from '@/application/interfaces/service';

export type PostalCode = {
  number: string;
  type: string;
  description?: string | null;
};

export type Address = {
  city: string;
  complement: string;
  district: string;
  ibgeCode: string;
  number: string;
  reference: string;
  state: string;
  street: string;
  main: boolean;
  externalSource: boolean;
  hasGarden: boolean;
  hasPool: boolean;
  nickname: string;
  hash: string;
  postalCode: PostalCode;
};

export type Phone = {
  number: number;
  default: boolean;
  externalSource: boolean;
  type: string;
};

export type Email = {
  address: string;
  main: boolean;
  payment: boolean;
};

export type Customer = {
  name: string;
  birthdate: string;
  gender: string;
  phones: Phone[];
  loyalty: {
    status: number;
    profession: string;
    favoriteStore: string;
    preferences: string[];
  };
  celebre: {
    status: string;
    canSubscribe: boolean;
  };
};

export type Response = {
  data: {
    identifier: number;
    type: string;
    emails: Email[];
    optins: {
      direct_mail: boolean;
      email: boolean;
      phone_number: boolean;
      push_notification: boolean;
      sms: boolean;
      whats_app: boolean;
    };
    addresses: Address[];
    customer: Customer;
  };
};

const getProfile: ServiceMethod<Response> = (httpClient) => async (options) => {
  const { body: response } = await httpClient.get<Response>(
    '/api/v3/account/profile',
    options
  );

  return response;
};

export default getProfile;
